module.exports = __webpack_public_path__ + "static/media/august.99eac292.jpg";